<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="5"
        viewBox="0 0 15 5"
        fill="none"
    >
        <path d="M10.602 3.84264V0H11.3703V3.84264H10.602Z" fill="#F7A600" />
        <path
            d="M1.6472 4.98412H0V1.14148H1.58097C2.34933 1.14148 2.79703 1.56243 2.79703 2.2209C2.79703 2.64714 2.5095 2.92258 2.31048 3.0143C2.54804 3.12218 2.85212 3.36499 2.85212 3.87795C2.85212 4.59551 2.34933 4.98412 1.6472 4.98412ZM1.52015 1.81083H0.768354V2.69593H1.52015C1.84623 2.69593 2.02868 2.5178 2.02868 2.25323C2.02868 1.98896 1.84623 1.81083 1.52015 1.81083ZM1.56983 3.37058H0.768354V4.31506H1.56983C1.91817 4.31506 2.08377 4.09931 2.08377 3.84004C2.08377 3.58105 1.91787 3.37058 1.56983 3.37058Z"
            fill="#17181D"
        />
        <path
            d="M5.19566 3.4082V4.98412H4.43273V3.4082L3.24979 1.14148H4.08438L4.81961 2.69035L5.54372 1.14148H6.37831L5.19566 3.4082Z"
            fill="#17181D"
        />
        <path
            d="M8.55666 4.98412H6.90945V1.14148H8.49043C9.25878 1.14148 9.70648 1.56243 9.70648 2.2209C9.70648 2.64714 9.41895 2.92258 9.21994 3.0143C9.45749 3.12218 9.76159 3.36499 9.76159 3.87795C9.76159 4.59551 9.25878 4.98412 8.55666 4.98412ZM8.42961 1.81083H7.67781V2.69593H8.42961C8.75568 2.69593 8.93813 2.5178 8.93813 2.25323C8.93813 1.98896 8.75568 1.81083 8.42961 1.81083ZM8.47928 3.37058H7.67781V4.31506H8.47928C8.82763 4.31506 8.99322 4.09931 8.99322 3.84004C8.99322 3.58105 8.82763 3.37058 8.47928 3.37058Z"
            fill="#17181D"
        />
        <path
            d="M13.8467 1.81083V4.98441H13.0784V1.81083H12.0502V1.14148H14.8749V1.81083H13.8467Z"
            fill="#17181D"
        />
    </svg>
</template>
